import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import autobind from 'react-autobind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FormBase from '../FormBase';

import SignUp from './SignUp';
import TermsAndConditions from './TermsAndConditions';
import Finish from './Finish';
import MetaComponent from '../../components/MetaTags';

import {
  changeStep,
  updatePatientInfo,
  submitForm,
  clearEnrollForm,
} from '../../actions/pharmaEnrollForm';
import { homeRedirectOnFinish } from '../../utils/utils';

class PharmaEnroll extends Component {
  constructor (props) {
    super(props);
    autobind(this);
    const { dispatch } = props;
    this.boundActionCreators = bindActionCreators({
      changeStep,
      updatePatientInfo,
      submitForm,
      clearEnrollForm,
    }, dispatch);
    this.state = {
      path: '',
      formReady: false,
    };
    this.lastPathname = props.location.pathname;
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (!nextProps.isLoading && (nextProps.success.status || nextProps.error.code) && !prevState.formReady) {
      nextProps.history.push(`/${nextProps.match.params.environment}${prevState.path}`);
      return {
        ...prevState,
        formReady: true,
      };
    }
    return prevState;
  }

  componentDidMount () {
    window.addEventListener('popstate', this.handleBackButton);
  }

  componentWillUnmount () {
    this.setState({
      formReady: false,
    });
    this.props.dispatch(clearEnrollForm());
    window.removeEventListener('popstate', this.handleBackButton);
  }

  componentDidUpdate (prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.lastPathname = prevProps.location.pathname;
    }
  }

  handleBackButton () {
    const { history, match } = this.props;

    homeRedirectOnFinish(history, match, this.lastPathname, 'pharmacist');
  }

  handleOnChangeField (payload) {
    const { dispatch } = this.props;
    dispatch(updatePatientInfo(payload));
  }

  handleOnSubmitForm = ({ values, path }) => {
    this.handleOnChangeField(values);
    this.setState({
      path,
    });
    this.props.dispatch(submitForm());
  };

  handleOnSubmitSignUp = ({ values, path }) => {
    this.handleOnChangeField(values);
    this.props.history.push(`/${this.props.match.params.environment}${path}`);
  };

  render () {
    const { params } = this.props.match;
    const formType = 'enroll';
    const { drugAnswers } = this.props.patientInformation;
    const { status } = this.props.success;
    const { code } = this.props.error;
    return (
      <FormBase
        environment={ params.environment }
        patientName="PhyllisShort"
        customClass="form pharma-screen"
        isLoading={ this.props.isLoading }
      >
        <Switch>
          <Route
            path={ `/${params.environment}/pharmacist/enroll/eligibility` }
            component={ props =>
              !this.props.source
                ? (
                  <Redirect to="/" />
                )
                : (
                  <React.Fragment>
                    <MetaComponent
                      title="Eligibility | Takeda Oncology Co-Pay Assistance Program"
                      ogMetas={ [{ property: 'og:title', content: 'Eligibility | Takeda Oncology Co-Pay Assistance Program' },
                        { property: 'og:url', content: `https://www.takedaoncologycopay.com/${params.environment}/pharmacist/enroll/eligibility` }] }
                      canonicalLink={ `/${params.environment}/pharmacist/enroll/eligibility` }
                    />
                    <TermsAndConditions
                      environment={ params.environment }
                      onSubmit={ this.handleOnSubmitSignUp }
                      formType={ formType }
                    />
                  </React.Fragment>
                ) }
          />
          <Route
            path={ `/${params.environment}/pharmacist/enroll/patient-information` }
            component={ props =>
              drugAnswers.hasMedicaid === null
                ? (
                  <Redirect to={ `/${params.environment}/pharmacist/enroll/eligibility` } />
                )
                : (
                  <React.Fragment>
                    <MetaComponent
                      title="Patient Information | Takeda Oncology Co-Pay Assistance Program"
                      ogMetas={ [{ property: 'og:title', content: 'Patient Information | Takeda Oncology Co-Pay Assistance Program' },
                        { property: 'og:url', content: `https://www.takedaoncologycopay.com/${params.environment}/pharmacist/enroll/patient-information` }] }
                      canonicalLink={ `/${params.environment}/pharmacist/enroll/patient-information` }
                    />
                    <SignUp
                      environment={ params.environment }
                      onSubmit={ this.handleOnSubmitForm }
                      formType={ formType }
                    />
                  </React.Fragment>
                )
            }
          />
          <Route
            path={ `/${params.environment}/pharmacist/enroll/finish` }
            component={ props =>
              !status && !code
                ? (
                  <Redirect to="/" />
                )
                : (
                  <React.Fragment>
                    <MetaComponent
                      title="Success | Takeda Oncology Co-Pay Assistance Program"
                      ogMetas={ [{ property: 'og:title', content: 'Success | Takeda Oncology Co-Pay Assistance Program' },
                        { property: 'og:url', content: `https://www.takedaoncologycopay.com/${params.environment}/pharmacist/enroll/finish` }] }
                      canonicalLink={ `/${params.environment}/pharmacist/enroll/finish` }
                    />
                    <Finish
                      environment={ params.environment }
                      cardId={ this.props.success.cardNumber || '' }
                      cardBin={ this.props.success.cardBin || '' }
                      cardPcn={ this.props.success.cardPcn || '' }
                      groupId={ this.props.success.cardGroup || '' }
                      enrollmentStatus={ this.props.success.status || '' }
                      enrollmentError={ this.props.error.code || '' }
                    />
                  </React.Fragment>
                )
            }
          />
        </Switch>
      </FormBase>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.pharmaEnrollForm.loading,
  patientInformation: state.pharmaEnrollForm.patientInformation,
  success: state.pharmaEnrollForm.success,
  error: state.pharmaEnrollForm.error,
  source: state.options.source,
});

export default withRouter(connect(mapStateToProps)(PharmaEnroll));
